interface IconTitleProps {
  open: boolean;
  link: {
    id: string | number;
    type: string;
    css?: string;
    pageType?: string;
    name?: string;
    icon?: string;
    color?: string;
  };
}
const IconTitle = ({ open, link }: IconTitleProps) => {
  return (
    <div>
      {open ? (
        <div className="tw:flex tw:items-center tw:pl-2">
          <i
            className={`${link.icon} ${link.color} tw:text-primary`}
            style={{ fontSize: 22, lineHeight: 0 }}
          />
          <h4 className={`tw:mb-0 tw:pl-2 ${link.color} tw:text-dark`}>
            {link.name}
          </h4>
        </div>
      ) : (
        <div className="tw:text-center">
          <i className={link.icon} style={{ fontSize: 22 }} />
        </div>
      )}
    </div>
  );
};

export default IconTitle;
